/*
 * @Author: Json Chen
 * @Date: 2021-06-16 16:35:31
 * @LastEditTime: 2022-05-27 17:39:00
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/LinkLibrary/index.tsx
 */

// import _ from 'lodash';
import { Filter, NoDataPage } from '@/src/components';
import { Button, SizeFittingTable } from '@/src/components/Antd';
import CommonHeader from '@/src/components/CommonHeader';
import WhiteBackgroundTooltip, {
  TooltipContainer,
  TooltipContent,
} from '@/src/components/GlobalTooltip/WhiteBackgroundTooltip';
import Pagination from '@/src/components/StyledPagination/GlobalPagination';
import {
  deleteLinkedLibrary,
  getResourceList,
} from '@/src/request/settings/linkLibrary';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import {
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
  EPermissionSource,
} from '@/src/types/common/resources';
import { modal } from '@/src/utils/Modal';
import useUrlState from '@ahooksjs/use-url-state';
import { LinkOutlined } from '@ant-design/icons';
import { useRequest } from 'ahooks';
import { Spin, Tabs } from 'antd';
import React from 'react';
import { useHistory } from 'react-router';
import Actions from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import { defaultPageSize } from 'src/tools/constant';
import { EnumTablePosition } from 'src/types/common/common';
import { breadcrumbData } from './config';
import styles from './style.module.less';
import { LinkType } from './type';
import { getBasicSetting } from 'src/constrains/GlobalProvider/slice';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { entireTimeFormat1 } from 'src/tools/constant';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const useColumns = (tab: LinkType, onDelete, canDelete: boolean) => {
  const [columns, setColumns] = React.useState([]);
  const config = useSelector(getBasicSetting());
  const { timezone } = config;
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  React.useEffect(() => {
    switch (tab) {
      case LinkType.URL:
        setColumns([
          {
            title: getI18n('general.title'),
            key: 'title',
            default: true,
            minWidth: 385,
            sorter: true,
            childGenerate: (_, record) => {
              return (
                <div className={styles.products}>
                  <div>{record.title}</div>
                  {record.relatedMiniProgram && (
                    <div className={styles.mini}>
                      <LinkOutlined
                        style={{
                          transform: 'rotate(45deg)',
                          color: '#38C568',
                        }}
                      />
                      <span className={styles.miniText}>
                        {record.relatedMiniProgram.title}
                      </span>
                    </div>
                  )}
                </div>
              );
            },
          },
          {
            title: getI18n('general.uRL'),
            dataIndex: 'url',
            key: 'url',
            default: true,
            width: 524,
            childGenerate: (text, record, index) => {
              return (
                <WhiteBackgroundTooltip
                  color={'#000'}
                  title={
                    <TooltipContainer>
                      <TooltipContent style={{ color: '#fff' }}>
                        {text}
                      </TooltipContent>
                    </TooltipContainer>
                  }
                  placement='bottom'>
                  {text}
                </WhiteBackgroundTooltip>
              );
            },
          },
          {
            title: `${getI18n('general.modified')} (${timezone})`,
            dataIndex: 'modifiedDate',
            key: 'modifiedDate',
            sorter: true,
            default: true,
            width: 189,
            childGenerate: (text, record, index) => {
              const t = moment(text).format(entireTimeFormat1);
              return t;
            },
          },
          {
            position: EnumTablePosition.mid,
            key: 'Actions',
            titleGenerate: () =>
              getI18n(
                'general.advancedFilters.commonStoreProductsWithTable.actions',
              ),
            dataIndex: 'Actions',
            childGenerate: (url, record, index) => {
              return (
                <Actions
                  disableDelete={!canDelete}
                  onDelete={(e) => {
                    // e.stopPropagation();
                    if (onDelete) {
                      onDelete(record);
                    }
                  }}
                />
              );
            },
            default: true,
            width: 189,
          },
        ]);
        break;
      case LinkType.MiniProgram:
        setColumns([
          {
            title: getI18n('general.title'),
            key: 'title',
            default: true,
            minWidth: 385,
            sorter: true,
            childGenerate: (_, record) => {
              return (
                <div className={styles.products}>
                  <div>{record.title}</div>
                  {record.relatedMiniProgram && (
                    <div>
                      <LinkOutlined
                        style={{
                          transform: 'rotate(45deg)',
                          color: '#38C568',
                        }}
                      />
                      <span>{record.relatedMiniProgram.title}</span>
                    </div>
                  )}
                </div>
              );
            },
          },
          {
            title: getI18n('storeLinkLibrary.detail.miniProgramAppID'),
            dataIndex: 'appID',
            key: 'appID',
            default: true,
            width: 524,
            childGenerate: (text, record, index) => {
              return (
                <WhiteBackgroundTooltip
                  color={'#000'}
                  title={
                    <TooltipContainer>
                      <TooltipContent style={{ color: '#fff' }}>
                        {text}
                      </TooltipContent>
                    </TooltipContainer>
                  }
                  placement='bottom' //overlayClassName
                >
                  {text}
                </WhiteBackgroundTooltip>
              );
            },
          },
          {
            title: `${getI18n('general.modified')} (${timezone})`,
            dataIndex: 'modifiedDate',
            key: 'modifiedDate',
            sorter: true,
            default: true,
            width: 189,
            childGenerate: (text, record, index) => {
              const t = moment(text).format(entireTimeFormat1);
              return t;
            },
          },
          {
            position: EnumTablePosition.mid,
            key: 'Actions',
            titleGenerate: () =>
              getI18n(
                'general.advancedFilters.commonStoreProductsWithTable.actions',
              ),
            childGenerate: (url, record, index) => {
              return (
                <Actions
                  disableDelete={!canDelete}
                  onDelete={(e) => {
                    // e.stopPropagation();
                    if (onDelete) {
                      onDelete(record);
                    }
                  }}
                />
              );
            },

            default: true,
            width: 189,
          },
        ]);
        break;
    }
  }, [tab, timezone]);

  return columns;
};

const LinkLibrary = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  const canViewList = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLinkLibrary,
        operation: EnumOperation.view_link_library_listing_page,
      }),
    ],
  });
  const canViewDetail = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLinkLibrary,
        operation: EnumOperation.view_link_details,
      }),
    ],
  });
  const canCreate = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLinkLibrary,
        operation: EnumOperation.create_edit_link,
      }),
    ],
  });
  const canDelete = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsLinkLibrary,
        operation: EnumOperation.delete_link,
      }),
    ],
  });
  const history = useHistory();
  // 用法见: https://ahooks.js.org/zh-CN/hooks/state/
  const [{ tab = LinkType.URL }, setTab] = useUrlState();
  const [_searchValue, _setSearchValue] = React.useState<string>('');
  const [searchValue, setSearchValue] = React.useState<string>('');
  const [current, setCurrent] = React.useState<number>(1);
  const [pageSize, setPageSize] = React.useState<number>(defaultPageSize);
  const [sortBy, setSortBy] = React.useState<{
    // 根据哪个字段排序
    field: string;
    // 升序 | 降序
    ascent: boolean;
  }>({
    field: 'modifiedDate',
    ascent: false,
  });

  const handleOnDelete = (link) => {
    if (!canDelete) {
      return false;
    }
    const { uuid, hasLinkedItems } = link;
    if (hasLinkedItems) {
      modal.info({
        title: getI18n('storeLinkLibrary.detail.deletelink'),
        content: getI18n('storeLinkLibrary.detail.deletelinkTip'),
        onOkText: getI18n('storeLinkLibrary.detail.gotounlinkitems'),
        onOk: () => {
          handleOnRowClick(link);
        },
        onCancel: () => {
          console.log('cancel');
        },
        danger: false,
      });
    } else {
      modal.error({
        title: getI18n('storeLinkLibrary.detail.deletelink'),
        content: getI18n('storeLinkLibrary.detail.deletetip2'),
        onOkText: getI18n('general.delete'),
        onOk: () => {
          onDelete(uuid);
        },
        onCancel: () => {
          console.log('cancel');
        },
        danger: true,
      });
    }
  };

  const onDelete = (uuid) => {
    deleteLinkedLibrary(uuid).then((res) => {
      run();
    });
  };

  const columns = useColumns(tab, handleOnDelete, canDelete);

  const onTabChange = (value) => {
    setTab({
      tab: value,
    });
  };
  const handleClickAdd = () => {
    if (canCreate) {
      history.push(`/settings/linkLibrary/Edit`);
    }
  };
  const onGoBackClick = () => {
    history.push(`/settings`);
  };

  const handleOnRowClick = (record) => {
    if (canViewDetail) {
      history.push(`/settings/linkLibrary/Edit/${record.uuid}`);
    }
  };
  const onTableChange = (__pagination, __filters, sorter) => {
    if (sorter.columnKey && sorter.order) {
      setSortBy({
        field: sorter.columnKey,
        ascent: sorter.order === 'ascend',
      });
    }
  };

  const handleOnRow = (record) => {
    // 行事件,详见antd Table组件
    return {
      onClick: () => handleOnRowClick(record), // 点击行
    };
  };

  const onSearchChange = (v) => {
    _setSearchValue(v);
  };

  const {
    loading,
    data = {},
    run,
  } = useRequest(
    () => {
      return getResourceList((current - 1) * pageSize, pageSize, {
        category: tab,
        searchText: [searchValue],
        sortBy: sortBy,
      });
    },
    {
      ready: !!canViewList,
      refreshDeps: [tab, searchValue, sortBy, pageSize, current],
      debounceInterval: 500,
      throttleInterval: 500,
    },
  );

  const pressEnter = (e) => {
    const { value } = e.target;
    setSearchValue(value);
  };

  const list = data.results || [];
  const total = data.totalCount || 0;
  return (
    <div className={styles.container}>
      {/* <button onClick={run}>123</button> */}
      <CommonHeader
        breadcrumbData={breadcrumbData({ getI18n })}
        onGoBackClick={onGoBackClick}
      />
      <div className={styles.contentWrap}>
        <Spin spinning={loading}>
          {!total && !searchValue ? (
            <NoDataPage
              title={getI18n('storeLinkLibrary.detail.addlinkstolinklibrary')}
              introduce={getI18n('storeLinkLibrary.detail.addTip')}
              renderButton={() => (
                <div className={styles.addBtnContainer}>
                  <Button
                    type='primary'
                    onClick={handleClickAdd}
                    disabled={!canCreate}>
                    {getI18n('storeLinkLibrary.list.addLink')}
                  </Button>
                </div>
              )}
            />
          ) : (
            <div className={styles.content}>
              <div className={styles.title}>
                <span className={styles.titleLeft}>
                  <span>{getI18n('settings.list.linkLibrary')}</span>
                </span>
                <span className={styles.titleRight}>
                  <Button
                    type='primary'
                    onClick={handleClickAdd}
                    disabled={!canCreate}>
                    {getI18n('storeLinkLibrary.list.addLink')}
                  </Button>
                </span>
              </div>
              <div className={styles.tabs}>
                <Tabs
                  tabBarStyle={{ height: '56px' }}
                  activeKey={tab}
                  onChange={onTabChange}>
                  <Tabs.TabPane
                    tab={
                      <div className={styles.tabPane}>
                        {getI18n('general.uRL')}
                      </div>
                    }
                    key={LinkType.URL}></Tabs.TabPane>
                  <Tabs.TabPane
                    tab={
                      <div className={styles.tabPane}>
                        {getI18n('general.miniProgram')}
                      </div>
                    }
                    key={LinkType.MiniProgram}></Tabs.TabPane>
                </Tabs>
              </div>
              <div className={styles.action}>
                {canViewList ? (
                  <Filter
                    placeholder={
                      tab == LinkType.URL
                        ? `${getI18n('general.title')},${getI18n(
                            'general.uRL',
                          )}`
                        : `${getI18n('general.title')},APPID`
                    }
                    searchValue={_searchValue}
                    searchOnchange={onSearchChange}
                    pressEnter={(e) => {
                      pressEnter(e);
                    }}
                    onSearch={setSearchValue}
                  />
                ) : null}
              </div>

              <div className={styles.table}>
                <SizeFittingTable
                  rowKey='uuid'
                  pagination={false}
                  id='salesChannelProductList'
                  dataSource={list}
                  columns={columns}
                  rowClassName={styles.row}
                  onChange={onTableChange}
                  onRow={handleOnRow}
                />
                <Pagination
                  current={current}
                  total={total}
                  pageSize={pageSize}
                  pageOnChange={setCurrent}
                  pageSizeChange={(e) => {
                    setPageSize(e.value);
                    setCurrent(1);
                  }}
                  paginationProps={{
                    defaultPageSize: pageSize,
                    showQuickJumper: true,
                  }}
                />
              </div>
            </div>
          )}
        </Spin>
      </div>
    </div>
  );
};
export default LinkLibrary;
